import styled from 'styled-components';
import { Column } from 'components/layout';

export const Container = styled(Column)`
  position: fixed;
  top: 68px;
  right: 20px;
`;
